import axios from "axios";
import constants from "../constants";

export async function getCountryRegion(country) {
  let today = new Date().getDay();
  return await axios.get(
    `${constants.REGIONS_API_BASE_URL}${country}/${today}`
  );
}
